<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('common.landlord') }}</h1>
      <div class="details-component__header_right" v-if="!isDeleted() && landlords.total > 0">
        <router-link :to="{name: 'edit-landlord', params: { id: selectedLandlordId }}" class="link" v-if="selectedLandlordId">
          {{ $t('common.change') }}
          <i class="icon icon--arrow"></i>
        </router-link>

        <!-- <a v-if="tenant.user && !tenant.user.account_created && tenant.user.email !== ''" href="#" class="link--orange" @click="activateTenantAccount(tenant.user.id)">{{ $t('tenant_details.create_account') }}
          <i class="icon icon--plus"></i>
        </a>-->
        <!--<a v-if="tenant.user && tenant.user.account_created && tenant.user.email !== ''" href="#" class="link" @click="resetPassword(tenant.user.email)">Taasta parool
          <i class="icon icon--plus"></i>
        </a>-->
        <a v-if="isSuperAdmin()" v-on:click="showDeletingConfirmation" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i></a>
      </div>
    </div>
    <div class="details-component__content content">
      <table class="details-table tenant no-col-padding label-r-padding fixed-table label-col-wide-150">
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.landlord') }}</td>
          <td class="details-table__col tenant__name">{{ landlord.name }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.contact_person') }}</td>
          <td class="details-table__col">{{ landlord.contactPerson }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.address') }}</td>
          <td class="details-table__col">{{ landlord.address }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.phone') }}</td>
          <td class="details-table__col">{{ landlord.phoneNumber }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('tenant_details.since') }}</td>
          <td class="details-table__col">{{ landlord.createdAt }}</td>
        </tr>
        <tr class="details-table__row">
          <td class="details-table__col details-table__col_label">{{ $t('common.email') }}</td>
          <td class="details-table__col">{{ landlord.email }}</td>
        </tr>
        <tr class="details-table__row" v-if="landlord.zones">
          <td class="details-table__col details-table__col_label">{{ $tc('common.zones', landlord.zones.length) }}</td>
          <td class="details-table__col">
            <template v-for="(zone, index) in landlord.zones">
              <span :key="zone.id">
                <router-link :to="{ name: 'zone', params: { id: zone.id } }" class="link link--blue">{{`${zone.code} (${zone.address})`}}</router-link><span v-if="index < (landlord.zones.length - 1)">,&nbsp;</span>
              </span>
            </template>
          </td>
          </tr>

        <tr class="divider" v-if="!landlord.isSuperAdmin">
          <td class="details-table__col txt-to-left" colspan="3">
            <div class="details-component__header">
              <h3>{{ $t('common.advanced_settings') }}</h3>
            </div>
          </td>
        </tr>

        <tr class="details-table__row auto-height" v-if="!landlord.isSuperAdmin">
          <td class="details-table__col txt-to-left padding-t-4 always-cell" colspan="3">
            <label class="form__label form__label__long no-hide with_checkbox">
              <input type="checkbox" id="can_exceed_capacity" name="can_exceed_capacity" disabled class="form__fieldset__checkbox" v-model="landlord.canChangeGuestParkingPrice">
              <span v-model="landlord.canChangeGuestParkingPrice" class="form__fieldset__custom-checkbox" disabled></span>
              <span class="custom-checkbox-label">{{ $t('landlord.can_change_guest_parking_price') }}</span>
            </label>
          </td>
        </tr>
        <tr class="details-table__row auto-height" v-if="!landlord.isSuperAdmin">
          <td class="details-table__col txt-to-left padding-t-4 always-cell" colspan="3">
            <label class="form__label form__label__long no-hide with_checkbox">
              <input type="checkbox" id="can_edit_kiosk_permits" name="can_edit_kiosk_permits" disabled class="form__fieldset__checkbox" v-model="landlord.canEditKioskPermits">
              <span v-model="landlord.canEditKioskPermits" class="form__fieldset__custom-checkbox" disabled></span>
              <span class="custom-checkbox-label">{{ $t('landlord.can_edit_kiosk_permits') }}</span>
            </label>
          </td>
        </tr>
        <tr class="details-table__row auto-height">
          <td class="details-table__col txt-to-left padding-t-4 always-cell" colspan="3">
            <label class="form__label form__label__long no-hide with_checkbox">
              <input type="checkbox" id="can_edit_kiosk_permits" name="can_edit_kiosk_permits" disabled class="form__fieldset__checkbox" v-model="landlord.scoroEnabled">
              <span v-model="landlord.scoroEnabled" class="form__fieldset__custom-checkbox" disabled></span>
              <span class="custom-checkbox-label">{{ $t('landlord.scoro_enabled') }}</span>
            </label>
          </td>
        </tr>

      </table>


      <ConfirmationModal v-if="showConfirmationModal" @cancel="cancelLandlordDelete" @confirmed="deleteLandlord">
        <h1 slot="header">{{ $t('common.deleting') }}: {{ landlord.name }} </h1>
        <p slot="body">{{ $t('landlords.confirm_delete') }}</p>
      </ConfirmationModal>

      <WarningModal v-if="showWarningModal" @close="closeWarningModal">
        <h1 slot="header">{{ landlordWarningHeader }}</h1>
        <p slot="body">{{ landlordWarningBody }}</p>
      </WarningModal>

    </div>
  </div>
</template>

<script>
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';

export default {
  props: ['landlord'],
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    selectedLandlordId: 'landlords/landlord/selectedLandlordId',
    landlordsError: 'landlords/landlord/error',
    landlords: 'landlord/landlords/landlords',
    user: 'user/user/user',
  }),
  methods: {
    isDeleted() {
      this.$emit('isDeleted', this.landlord.isDeleted);
      return this.landlord.isDeleted;
    },
    activateLandlordAccount(userId) {
      this.$store.dispatch('landlords/landlord/activateLandlordAccount', { user: userId }).then(() => {
        this.showModal = true;
      });
    },
    showDeletingConfirmation() {
      if (this.landlord.tenants > 0) {
        this.landlordWarningHeader = this.$t('landlords.cannot_remove');
        this.landlordWarningBody = this.$t('landlords.tenants_created');
        this.showWarningModal = true;
      } else {
        this.showConfirmationModal = true;
      }
    },
    deleteLandlord() {
      this.showConfirmationModal = false;
      this.$store.dispatch('landlords/landlord/delete', { id: this.selectedLandlordId, user: this.user }).then(() => {
        if (this.LandlordsError) {
          this.landlordWarningHeader = this.$t('common.error');
          this.landlordWarningBody = this.$t('landlords.delete_error');
          this.showWarningModal = true;
        } else {
          this.$store.commit(`landlord/landlords/${mTypes.REMOVE_DATA}`, this.selectedLandlordId);
          this.$router.push({ name: 'landlords' });
        }
      });
    },
    cancelLandlordDelete() {
      this.showConfirmationModal = false;
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`landlords/landlord/${mTypes.DATA_ERROR}`, null);
    },
  },
  data() {
    return {
      showConfirmationModal: false,
      showWarningModal: false,
      landlordWarningBody: null,
      landlordWarningHeader: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/blocks/details.scss';

.tenant__name {
  font-size: 24px;
  font-family: 'Geogrotesque Md', sans-serif;
}

.link--orange {
  .icon--plus {
    position: relative;
    top: 1px;
    margin: 0;
    font-weight: 900;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landlords/LandlordDetails.vue